module.exports = "<div class=\"remodal\" data-remodal-id=\"<%= id %>\">\n  <button data-remodal-action=\"close\" class=\"remodal-close\"></button>\n  <p class=\"caption\"><%= caption %></p>\n  <img src=\"<%= src %>\" alt=\"\">\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./dev/js/scripts/_remodal_template.html
// module id = 15
// module chunks = 0